import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import ReactMarkdown from "react-markdown";
import withContentfulTag from "../../utils/withContentfulTag";

const PriceCapTariffInfoPanel = ({ contentful }) => {
  if (!contentful) return null;

  return (
    <div className="mt-6 mb-8 border-2 border-primary rounded-[4px] p-4">
      <Disclosure>
        {({ open }) => (
          <>
            <p className="font-bold">{contentful?.title}</p>
            <DisclosureButton className="mt-3 flex items-center gap-2 text-primary">
              <ChevronDownIcon
                className={`w-4 h-4 transition-transform ${
                  open ? "rotate-180 transform" : ""
                }`}
              />
              <span className="font-bold">
                {open ? "Hide" : "Show"} information
              </span>
            </DisclosureButton>
            <DisclosurePanel className="mt-4">
              <ReactMarkdown className="markdown">
                {contentful?.body}
              </ReactMarkdown>
            </DisclosurePanel>
          </>
        )}
      </Disclosure>
    </div>
  );
};

export default withContentfulTag(
  PriceCapTariffInfoPanel,
  "switching_price_cap_tariff_info_panel"
);
